import React from 'react';
import './Footer.css';
import logo from '../assets/logo.png';
import hidevLogo from '../assets/hidev_logo.png';

const Footer: React.FC = () => {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer" id="contact">
      <div className="footer-container">
        {/* Desktop Layout */}
        <div className="footer-desktop">
          {/* Logo Section */}
          <div className="footer-logo">
            <img src={logo} alt="San Mateo Orthodontics" />
          </div>

          {/* Navigation Links */}
          <nav className="footer-nav">
            <ul>
              <li>
                <button onClick={() => scrollToSection('hero')}>Home</button>
              </li>
              <li>
                <button onClick={() => scrollToSection('services')}>Services</button>
              </li>
              <li>
                <button onClick={() => scrollToSection('office')}>Our Office</button>
              </li>
              <li>
                <button onClick={() => scrollToSection('staff')}>Our Staff</button>
              </li>
              <li>
                <button onClick={() => scrollToSection('registration')}>New Patient</button>
              </li>
              <li>
                <a
                  href="https://bestcardteam.com/Payments/?Profile=ellerhorstddsWEB"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Pay Online
                </a>
              </li>
            </ul>
          </nav>

          {/* HiDev Logo */}
          <div className="footer-hidev">
            <a
              href="https://hidevmobile.com"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Visit HiDev Mobile"
            >
              <img src={hidevLogo} alt="HiDev Mobile" />
            </a>
          </div>
        </div>

        {/* Mobile Layout */}
        <div className="footer-mobile">
          {/* Logo Section */}
          <div className="footer-logo-mobile">
            <img src={logo} alt="San Mateo Orthodontics" />
          </div>

          {/* Navigation Links - Two Columns */}
          <nav className="footer-nav-mobile">
            <div className="footer-nav-column">
              <ul>
                <li>
                  <button onClick={() => scrollToSection('hero')}>Home</button>
                </li>
                <li>
                  <button onClick={() => scrollToSection('services')}>Services</button>
                </li>
                <li>
                  <button onClick={() => scrollToSection('office')}>Our Office</button>
                </li>
              </ul>
            </div>
            <div className="footer-nav-column">
              <ul>
                <li>
                  <button onClick={() => scrollToSection('staff')}>Our Staff</button>
                </li>
                <li>
                  <button onClick={() => scrollToSection('registration')}>New Patient</button>
                </li>
                <li>
                  <a
                    href="https://bestcardteam.com/Payments/?Profile=ellerhorstddsWEB"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Pay Online
                  </a>
                </li>
              </ul>
            </div>
          </nav>

          {/* HiDev Logo */}
          <div className="footer-hidev-mobile">
            <a
              href="https://hidevmobile.com"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Visit HiDev Mobile"
            >
              <img src={hidevLogo} alt="HiDev Mobile" />
            </a>
          </div>
        </div>

        {/* Copyright */}
        <div className="footer-copyright">
          <p>&copy; {currentYear} San Mateo Orthodontics. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 